import { TemplateEntityPeriodicityEnum } from '@zaoblako/shared/common/enums/template.entity.periodicity.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CommonDtoKeysEnum } from '@zaoblako/shared/common/enums/common-dto-keys.enum';
import { DateFormatEnum } from '@zaoblako/shared/common/enums/date.format.enum';
import { dateFormatSchema } from '@zaoblako/shared/modules/serde/schemas/date-format.schema';

import * as yup from 'yup';

/** Planning unit settings response body */
export interface PlanningUnitFindInterface {
  /**
   * Concrete date of running. Must be defined only when
   * {@link PlanningUnitFindInterface.periodicity} property equals
   * {@link TemplateEntityPeriodicityEnum.NONE}.
   */
  runDate?: Date;
  /**
   * Day of week number. Must be defined only when
   * {@link PlanningUnitFindInterface.periodicity} property equals
   * {@link TemplateEntityPeriodicityEnum.WEEKLY}.
   */
  dayOfWeek?: number;
  /**
   * Day of month number. Must be defined only when
   * {@link PlanningUnitFindInterface.periodicity} property equals
   * {@link TemplateEntityPeriodicityEnum.MONTHLY} or
   * {@link TemplateEntityPeriodicityEnum.QUARTERLY}.
   */
  dayOfMonth?: number;
  /**
   * Month of quarter number. Must be defined only when
   * {@link PlanningUnitFindInterface.periodicity} property equals
   * {@link TemplateEntityPeriodicityEnum.QUARTERLY}.
   */
  monthOfQuarter?: number;
  /**
   * Month of year number. Must be defined only when
   * {@link PlanningUnitFindInterface.periodicity} property equals
   * {@link TemplateEntityPeriodicityEnum.ANNUALLY}.
   */
  monthOfYear?: number;
  /**
   * Running periodicity unit. Determines which fields must be
   * filled in and how the start date should be formed.
   */
  periodicity: TemplateEntityPeriodicityEnum;
  /** Running time */
  time?: string;
  /**
   * The nearest start date of the planning unit
   * relative to the current one
   */
  nearestDate: Date;
  /** Same value as {@link PlanningUnitFindInterface.nearestDate} but with time */
  nearestDateWithTime: Date;
}

/** Planning unit settings response body - DTO schema */
export const PlanningUnitFindDto = SerdeDtoClass.create<PlanningUnitFindInterface>(CommonDtoKeysEnum.PLANNING_UNIT_FIND_DTO, {
  runDate: {
    sortable: true,
    optional: true,
    label: 'Дата запуска',
    serializer: dateFormatSchema(DateFormatEnum.UTC_DATE_YY_FORMAT),
  },
  dayOfWeek: {
    optional: true,
    label: 'День недели',
    serializer: yup.number(),
  },
  dayOfMonth: {
    optional: true,
    label: 'День месяца',
    serializer: yup.number(),
  },
  monthOfQuarter: {
    optional: true,
    label: 'Месяц квартала',
    serializer: yup.number(),
  },
  monthOfYear: {
    optional: true,
    label: 'Месяц года',
    serializer: yup.number(),
  },
  periodicity: {
    label: 'Периодичность',
    serializer: yup
      .string()
      .oneOf(Object.values(TemplateEntityPeriodicityEnum)),
  },
  time: {
    label: 'Время',
    serializer: yup.string(),
  },
  nearestDate: {
    sortable: true,
    label: 'Ближайшая дата',
    serializer: yup.date(),
  },
  nearestDateWithTime: {
    sortable: true,
    label: 'Ближайшая дата и время',
    serializer: yup.date(),
  },
});
